import { render, staticRenderFns } from "./CustomerProductList.vue?vue&type=template&id=2a084ed5"
import script from "./CustomerProductList.vue?vue&type=script&lang=js"
export * from "./CustomerProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports